<div class="challenge-page">
  <div class="container-fluid pt-4">

    <div class="page-head">
      <div class="page-title-row" *ngIf="!editingCountdown">
        <h1 class="page-title">{{ countdownTitle }}</h1>
        <button
          type="button"
          class="title-edit-btn"
          (click)="startCountdownEdit()"
          [attr.aria-label]="countdown ? 'Edit countdown' : 'Set a target'">
          {{ countdown ? '✎' : '+' }}
        </button>
      </div>
      <div class="page-title-edit" *ngIf="editingCountdown">
        <input
          type="date"
          class="title-edit-input"
          [(ngModel)]="countdownDraftDate"
          aria-label="Target date">
        <input
          type="text"
          class="title-edit-input"
          [(ngModel)]="countdownDraftLabel"
          placeholder="Label (optional)"
          aria-label="Countdown label">
        <div class="title-edit-actions">
          <button type="button" class="title-edit-save" (click)="saveCountdownEdit()" [disabled]="!countdownDraftDate">Save</button>
          <button type="button" class="title-edit-cancel" (click)="cancelCountdownEdit()">Cancel</button>
          <button type="button" class="title-edit-remove" *ngIf="countdown" (click)="removeCountdownEdit()">Remove</button>
        </div>
      </div>
      <button class="history-btn" type="button" (click)="openHistory()" [disabled]="!userId">📅 History</button>
    </div>

    <div *ngIf="!userId && !loading" class="empty-state">
      <p>Sign in to use the challenge tracker.</p>
    </div>

    <div *ngIf="loading" class="empty-state"><p>Loading…</p></div>

    <div *ngIf="migrating" class="migration-overlay">
      <p>Importing your challenge data… (this only happens once)</p>
    </div>

    <div *ngIf="migrationSummary" class="migration-summary">{{ migrationSummary }}</div>

    <ng-container *ngIf="userId && !loading">

      <div class="mandala-row">
        <div class="mandala-col">
          <app-mandala
            [rings]="rings"
            [pulse]="pulse"
            [tierUp]="tierUp">
          </app-mandala>
          <app-mandala-icons (openSettings)="openMandalaSettings()"></app-mandala-icons>
          <div *ngIf="decayOverlay" class="decay-overlay">{{ decayOverlay }}</div>
        </div>
        <div class="stats-col">
          <app-stats-panel
            [rings]="rings"
            [dailyProgress]="dailyProgress"
            [weeklyProgress]="weeklyProgress">
          </app-stats-panel>
        </div>
      </div>

      <app-habit-list
        [dailyHabits]="dailyHabits"
        [weeklyHabits]="weeklyHabits"
        [completions]="completions"
        [streakByHabitId]="streakByHabitId"
        [availableCategories]="availableCategories"
        [activeFilter]="activeFilter"
        [today]="today"
        (filterChange)="setFilter($event)"
        (toggleDaily)="onToggleCompletion($event)"
        (toggleWeekly)="onWeeklyToggle($event)"
        (removeWeeklyCompletion)="onRemoveWeeklyCompletion($event)"
        (noteChange)="onNoteChange($event.completionId, $event.note)"
        (editHabit)="openEditHabit($event)"
        (addHabit)="openAddHabit()">
      </app-habit-list>

      <app-daily-journal
        [entry]="todayJournal"
        (textChange)="onJournalChange({ text: $event })"
        (generalRatingChange)="onJournalChange({ generalRating: $event === null ? undefined : $event })"
        (happinessRatingChange)="onJournalChange({ happinessRating: $event === null ? undefined : $event })">
      </app-daily-journal>

    </ng-container>

    <app-mandala-settings
      *ngIf="showMandalaSettings"
      [rings]="rings"
      [allActiveCategories]="availableCategories"
      (ringOrderChange)="onRingOrderChange($event)"
      (styleChange)="onStyleChange($event)"
      (visibleCategoriesChange)="onVisibleCategoriesChange($event)"
      (resetToDefaults)="onResetMandala()"
      (close)="closeMandalaSettings()">
    </app-mandala-settings>

    <app-habit-edit-modal
      *ngIf="showEditModal"
      [mode]="editHabit ? 'edit' : 'create'"
      [habit]="editHabit"
      [existingCategories]="availableCategories"
      [archivedHabits]="archivedHabits"
      (save)="onHabitSave($event)"
      (archive)="onArchive($event)"
      (unarchive)="onUnarchive($event)"
      (hardDelete)="onHardDelete($event)"
      (close)="closeEditModal()">
    </app-habit-edit-modal>

    <app-history-modal
      *ngIf="showHistoryModal"
      [habits]="habits"
      [completions]="completions"
      [journals]="journals"
      [today]="today"
      (toggleCompletion)="onHistoricalToggle($event.habit, $event.date)"
      (journalChange)="onHistoricalJournalChange($event.date, $event.patch)"
      (close)="closeHistory()">
    </app-history-modal>

  </div>
</div>
